import React, { useState } from "react";
import { Button, Input } from "../components/Form";
import { BiMailSend } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import authService from "../api/authService";

function ForgotPassword() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const submitHandler = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (!email) {
                toast.error("Please provide email");
                setLoading(false);
                return;
            }
            await authService.forgotPassword(email);
            toast.success("OTP sent to your email");
            navigate(`/reset-password?email=${encodeURIComponent(email)}`);
        } catch (error) {
            const msg = error.response?.data?.message || "Failed to send OTP";
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='flex-colo h-screen w-full bg-dry'>
            <form onSubmit={submitHandler} className='flex-colo mx-auto w-[90%] md:w-2/5 rounded-2xl bg-white p-8'>
                <img
                    src='/images/logo.png'
                    alt='logo'
                    className='h-16 w-48 object-contain'
                />
                <div className='mb-6 flex w-full flex-col gap-4 text-center mt-4'>
                    <h2 className='text-2xl font-bold text-gray-800'>Forgot Password</h2>
                    <p className='text-sm text-gray-500'>Enter your email to receive an OTP</p>
                    <div className='text-left'>
                        <Input
                            label='Email'
                            type='email'
                            color={true}
                            placeholder={"Enter your email address"}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                </div>
                <Button
                    label={loading ? "Loading..." : "Send OTP"}
                    Icon={BiMailSend}
                    onClick={submitHandler}
                    disabled={loading}
                />
            </form>
        </div>
    );
}

export default ForgotPassword;
